// test1922
(1922 && 0);
